import styled, { css } from 'styled-components';
import mq from '../../utils/mediaQueries.js';
import { focusOutline } from '../../utils/mixins.js';
import { isGlobetrotter } from '../../utils/theming.js';

var thumbSizeMobile = 32;
var thumbSizeDesktop = 24;
var Wrapper = styled.div.withConfig({
  displayName: "style__Wrapper",
  componentId: "sc-1kwxirt-0"
})(["display:flex;flex-direction:column;justify-content:flex-end;height:80px;"]);
var ValueContainer = styled.div.withConfig({
  displayName: "style__ValueContainer",
  componentId: "sc-1kwxirt-1"
})(["display:flex;justify-content:center;align-items:center;div{display:flex;justify-content:center;width:100%;}"]);
styled.div.withConfig({
  displayName: "style__TextContainer",
  componentId: "sc-1kwxirt-2"
})(["display:flex;justify-content:flex-start;"]);
var RangeLegend = styled.div.withConfig({
  displayName: "style__RangeLegend",
  componentId: "sc-1kwxirt-3"
})(["width:100%;margin-top:1.6rem;display:flex;justify-content:space-between;.sr-only{position:absolute;top:auto;width:1px;height:1px;overflow:hidden;opacity:0;}"]);
var SliderContainer = styled.div.withConfig({
  displayName: "style__SliderContainer",
  componentId: "sc-1kwxirt-4"
})(["display:flex;flex-direction:column-reverse;justify-content:center;align-items:center;"]);
var DoubleInputContainer = styled.div.withConfig({
  displayName: "style__DoubleInputContainer",
  componentId: "sc-1kwxirt-5"
})(["position:relative;width:100%;input.thumb{position:absolute;width:100%;top:10px;left:0;}input.thumb.thumb__low{z-index:", ";}input.thumb.thumb__high{z-index:", ";}"], function (props) {
  return props.$activeThumb === 'low' ? 4 : 3;
}, function (props) {
  return props.$activeThumb === 'high' ? 4 : 3;
});
var DoubleSliderTrackContainer = styled.div.withConfig({
  displayName: "style__DoubleSliderTrackContainer",
  componentId: "sc-1kwxirt-6"
})(["position:relative;width:100%;height:24px;margin-bottom:-1rem;justify-content:center;align-items:center;display:flex;&:hover{cursor:pointer;}"]);
var SingleInputContainer = styled.div.withConfig({
  displayName: "style__SingleInputContainer",
  componentId: "sc-1kwxirt-7"
})(["position:relative;width:100%;height:24px;margin-bottom:-1rem;justify-content:center;align-items:center;display:flex;&:hover{cursor:pointer;}"]);
var DoubleSliderRange = styled.div.attrs(function (props) {
  return {
    style: {
      background: !props.$hovered ? "linear-gradient(\n      90deg,\n      var(--color-grey-100) ".concat(props.$percent.low, "%,\n      var(--color-cta-button-primary) ").concat(props.$percent.low, "%,\n      var(--color-cta-button-primary) ").concat(props.$percent.high, "%,\n      var(--color-grey-100) ").concat(props.$percent.high, "%\n    )") : "linear-gradient(\n          90deg,\n          var(--color-grey-200) ".concat(props.$percent.low, "%,\n          var(--color-cta-button-primary-hover) ").concat(props.$percent.low, "%,\n          var(--color-cta-button-primary-hover) ").concat(props.$percent.high, "%,\n          var(--color-grey-200) ").concat(props.$percent.high, "%\n        )")
    }
  };
}).withConfig({
  displayName: "style__DoubleSliderRange",
  componentId: "sc-1kwxirt-8"
})(["transition:background ease-in-out 0.7s;border-radius:50em;height:4px;outline:none;z-index:0;width:100%;"]);
var InputRange = styled.input.attrs(function (props) {
  return {
    type: 'range',
    style: {
      background: !props.$hovered ? "linear-gradient(\n      90deg,\n      var(--color-cta-button-primary) ".concat(props.$percentage, "%,\n      var(--color-grey-100) ").concat(props.$percentage, "%\n    )") : "linear-gradient(\n      90deg,\n      var(--color-cta-button-primary-hover) ".concat(props.$percentage, "%,\n      var(--color-grey-200) ").concat(props.$percentage, "%\n    )")
    }
  };
}).withConfig({
  displayName: "style__InputRange",
  componentId: "sc-1kwxirt-9"
})(["border-radius:50em;width:100%;height:4px;padding-inline:0;padding-block:0;cursor:pointer;appearance:none;-webkit-appearance:none;-moz-appearance:none;outline:none;&:focus-visible{outline:none;box-shadow:none;&::-moz-range-thumb{", " border-radius:50em;}&::-webkit-slider-thumb{", " border-radius:50em;}}&::-webkit-slider-thumb{appearance:none;-webkit-appearance:none;-moz-appearance:none;width:", "px;height:", "px;border-radius:50%;background:var(--color-white);box-shadow:rgba(0,0,0,0.5) 0px 0px 5px;cursor:pointer;transition:box-shadow var(--transition),background var(--transition);", " .no-touch &:hover{box-shadow:0 0 5px rgba(0,0,0,0.7);}&:hover{transform:scale(0.97);}&:active{transform:scale(0.92);}", "}&::-moz-range-thumb{appearance:none;-webkit-appearance:none;-moz-appearance:none;width:", "px;height:", "px;border-radius:50%;background:var(--color-white);box-shadow:rgba(0,0,0,0.5) 0px 0px 5px;cursor:pointer;transition:box-shadow var(--transition),background var(--transition);", " .no-touch &:hover{box-shadow:0 0 5px rgba(0,0,0,0.7);}&:hover{transform:scale(0.97);}&:active{transform:scale(0.92);}}"], focusOutline, focusOutline, thumbSizeMobile, thumbSizeMobile, mq.s(css(["height:", "px;top:-10px;width:", "px;"], thumbSizeDesktop, thumbSizeDesktop)), isGlobetrotter(css(["box-shadow:none;border:1px solid var(--color-cta-button-primary);"])), thumbSizeMobile, thumbSizeMobile, mq.s(css(["height:", "px;top:-10px;width:", "px;"], thumbSizeDesktop, thumbSizeDesktop)));
var DoubleSliderThumb = styled(InputRange).withConfig({
  displayName: "style__DoubleSliderThumb",
  componentId: "sc-1kwxirt-10"
})(["pointer-events:none;.no-touch &{pointer-events:all;}"]);

export { DoubleInputContainer, DoubleSliderRange, DoubleSliderThumb, DoubleSliderTrackContainer, InputRange, RangeLegend, SingleInputContainer, SliderContainer, ValueContainer, Wrapper };
//# sourceMappingURL=style.js.map
